function AdminHome(){
    return (
        <div className="admin-component admin-home">
            <h1>Welcome to the admin console</h1>
            <p>Please select your designated tool from the panel.</p>
        </div>
    );
}

export default AdminHome;